<template>
  <div class="relative flex flex-col h-dvh items-center">
    <div
      class="absolute h-full w-full bg-[radial-gradient(theme(colors.border)_1px,transparent_1px)] [background-size:20px_20px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_60%,transparent_100%)]"
    />
    <div class="container relative z-10 flex flex-col items-center justify-center text-center my-auto">
      <p class="mb-5 font-bold tracking-tight text-primary">{{ error.statusCode }} error</p>
      <h1 class="text-4xl font-bold tracking-tight lg:text-5xl">{{ error.message }}</h1>
      <UiButton class="mt-5" @click="clearError({ redirect: '/' })">Ana Sayfaya Dön</UiButton>
      <UiDebug>{{ error }}</UiDebug>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const error = useError()
</script>
